import Vue from 'vue';
import App from './App.vue';
import '@/registerServiceWorker';
import '@/components';
import router from './router';
import store from './store';
import vuetify from './plugins';

import { sync } from 'vuex-router-sync';

Vue.config.productionTip = false;
Vue.config.performance = process.env.NODE_ENV === 'development';
sync(store, router);

new Vue({
  router,
  store,
  vuetify,
  created() {
    console.log('API URL', process.env.VUE_APP_API_URL);
  },
  render: h => h(App)
}).$mount('#app');
